/**
 * Turns a theme preference ("light", "dark" or "system") into the theme to draw.
 * "system" follows the operating system setting.
 */
export const resolveTheme = ({ preference, systemPrefersDark }) => {
  if (preference === 'light' || preference === 'dark') {
    return preference;
  }
  return systemPrefersDark ? 'dark' : 'light';
};
